import HttpClient from '../HttpService';

function getUsage(params = {}) {
    return HttpClient.get('/usage', { params });
}

export default {
    getUsage
};
